var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section border-bottom-section" }, [
    _c("div", { staticClass: "section-content" }, [
      _c(
        "div",
        {
          staticClass:
            "columns is-centered is-vcentered columns-text-title-left",
        },
        [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "title is-spaced has-text-centered" }, [
              _vm._v(_vm._s(_vm.$t("about.title4"))),
            ]),
            _c("ul", { staticClass: "subtitle" }, [
              _c("li", [_vm._v(_vm._s(_vm.$t("about.content4_l1")))]),
              _c("li", [_vm._v(_vm._s(_vm.$t("about.content4_l1_2")))]),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("about.content4_l2"))),
                _c("ol", [
                  _c("li", [_vm._v(_vm._s(_vm.$t("about.content4_l2_1")))]),
                  _c("li", [_vm._v(_vm._s(_vm.$t("about.content4_l2_2")))]),
                ]),
              ]),
              _c("li", [_vm._v(_vm._s(_vm.$t("about.content4_l3")))]),
              _c("li", [_vm._v(_vm._s(_vm.$t("about.content4_l4")))]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }